import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';

export interface CheckmarkTheme {
  primary?: string;
  secondary?: string;
}

export const CheckmarkIcon: React.FC = () => {
  return (
    <CheckCircleIcon className="h-6 w-6 text-green-400" aria-hidden="true" />
  );
};
